import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "TrapsModuleContainerHome": () => import("./components/TrapsModuleContainerHome.vue"),
    "TrapsDoubleTileContainerRight4on6": () => import("./components/TrapsDoubleTileContainerRight4on6.vue"),
    "TrapsDoubleTileContainerRight3on6": () => import("./components/TrapsDoubleTileContainerRight3on6.vue"),
    "TrapsSingleTileContainerResponsive": () => import("./components/TrapsSingleTileContainerResponsive.vue"),
    "TrapsAllFarmerTrapsInMapTile": () => import("./components/tiles/TrapsAllFarmerTrapsInMapTile.vue"),
    "TrapsAllFarmerTrapsTile": () => import("./components/tiles/TrapsAllFarmerTrapsTile.vue"),
    "TrapsTrapDetail": () => import("./components/tiles/TrapsTrapDetail.vue"),
    "TrapsViewAllReliefEvent": () => import("./components/tiles/TrapsViewAllReliefEvent.vue"),
    "TrapViewAllTrapEvents": () => import("./components/tiles/TrapViewAllTrapEvents.vue"),
    "TrapsUpdateTrap": () => import("./components/tiles/TrapsUpdateTrap.vue"),
    "TrapEditTrapForm": () => import("./components/tiles/TrapEditTrapForm.vue"),
    "TrapViewValidationPage": () => import("./components/tiles/TrapViewValidationPage.vue"),
    "TrapsEditTrapMap": () => import("./components/tiles/TrapsEditTrapMap.vue"),
    "TrapsAllCapturesChart": () => import("./components/tiles/TrapsAllCapturesChart.vue"),
};

export default globals;
